export const LANGUAGE_LABEL_LOCALE_ZHCHS = {
    en: 'è±è¯­',
    "zh-cn": 'ç®ä½ä¸­æ',
    "zh-CHS": 'ç®ä½ä¸­æ',
    "zh-CHT": 'ç¹ä½ä¸­æ',
    ok: 'ç¡®å®',
    cancel: 'åæ¶'
};
